import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "react-redux-form";
import { Grid, Row, Col, Button } from "react-bootstrap";
import StoreList from "./store-list";
import PageTitle from "../common/page-title/index";
import InlineCKEditor from "../common/editor/inline-editor";
import { getOutlets, updateOutletReward } from "../../actions/outlet";
import { loadPageContent } from "../../actions/content";

import "./store-summary.css";

class StoreSummary extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = "store-summary";
    this.stores = [];
  }

  componentWillMount() {
    if (this.props.registration.pending && this.props.registration.internal) {
      this.props.dispatch({ type: "FINISH_REGISTRATION" });
      this.props.dispatch(getOutlets(false, true));
    } else {
      this.props.dispatch(getOutlets(this.props.registration.pending, true));
    }

    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  onNextClicked = () => {
    this.props.dispatch({ type: 'FINISH_REGISTRATION' });
    window.location.href = '/';
  };

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <Grid
        bsClass="container"
        className="stores store-summary-container"
      >
        <Row>
          <Col lg={12}>
            <PageTitle>Store summary</PageTitle>
          </Col>
        </Row>

        <br />
        {!this.props.registration.pending && (
          <Row>
            <Col lg={12}>
              <InlineCKEditor
                identifier={`${this.pageSlug}_content_text`}
                onContentSaved={this.handleContentSaved}
                contents={
                  this.props.contents[`${this.pageSlug}_content_text`]
                }
              />
            </Col>
          </Row>
        )}
        <br />
        <Col lg={12}>
          <StoreList
            registration={this.props.registration}
            stores={this.props.stores}
            vouchers={this.props.vouchers}
            fetching={this.props.fetching}
            fetched={this.props.fetched}
          />
        </Col>
        <br />
        {this.props.registration.pending &&
          !this.props.registration.internal && (
            <Col lg={12} className="next-button">
              <Button
                bsStyle="primary"
                className="red-ghost-btn next-button--container"
                // block={true}
                onClick={this.onNextClicked}
                disabled={!this.props.form.valid}
              >
                Next
              </Button>
            </Col>
          )}
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stores: state.stores.stores,
    vouchers: state.stores.vouchers,
    fetched: state.stores.fetched,
    fetching: state.stores.fetching,
    registration: state.registration,
    storeRewards: state.deep.store_summary,
    contents: state.content.list,
    form: state.deep.forms.store_summary.$form,
  };
};

export default connect(mapStateToProps)(StoreSummary);



// WEBPACK FOOTER //
// ./src/components/store-summary/index.jsx